import { useQuery } from "@tanstack/react-query";
import fetchToBackend, { buildQuery } from "@/utils/fetchToBackend";
import { adminKeys } from "@/lib/query-keys";
import type { ContractingFileErrorReport } from "@/types/domain";

export interface ContractingErrorFilters {
  stages?: string[];
  publicatedFrom?: string;
  publicatedTo?: string;
  sortBy?: "publicatedAt" | "amount";
}

/** Licitaciones cuyos documentos fallaron al procesarse (panel admin). */
export function useAdminContractingErrors(
  filters: ContractingErrorFilters = {},
) {
  return useQuery({
    queryKey: adminKeys.contractingErrors(filters),
    queryFn: async () => {
      const query = buildQuery({
        stages: filters.stages,
        publicatedFrom: filters.publicatedFrom,
        publicatedTo: filters.publicatedTo,
        sortBy: filters.sortBy,
      });
      const res = await fetchToBackend<any>(
        `/admin/contractings-errors${query}`,
      );
      return (res?.data ?? res ?? []) as ContractingFileErrorReport[];
    },
  });
}
